import { useTranslation } from 'react-i18next';
import Button from '../core/button/CoreButton';
import CardCenteredContent from '../core/card/CardCenteredContent';
import CardIcon from '../core/card/CardIcon';
import { CardSmallGrid } from '../core/card/CommonCardLayouts';

export default function SdkOptionsGrid() {
    const { t } = useTranslation();
    return (
        <CardSmallGrid>
            <CardIcon
                name="javaScript"
                title={t('common:developer.sdk.javascript.title')}
                description={t('common:developer.sdk.javascript.description')}>
                <Button
                    endIcon="externalLink"
                    $color="subsection"
                    href="https://www.npmjs.com/package/@cephable/cephable-web">
                    {t('common:developer.sdk.javascript.action')}
                </Button>
            </CardIcon>
            <CardIcon
                name="windows11"
                title={t('common:developer.sdk.net.title')}
                description={t('common:developer.sdk.net.description')}>
                <Button endIcon="externalLink" $color="subsection" href="https://www.nuget.org/packages/Cephable.Core">
                    {t('common:developer.sdk.net.actionCore')}
                </Button>
                <Button endIcon="externalLink" $color="subsection" href="https://www.nuget.org/packages/Cephable.WPF">
                    {t('common:developer.sdk.net.actionWpf')}
                </Button>
            </CardIcon>
            {/* <CardIcon
                name="androidOs"
                title={t('common:developer.sdk.android.title')}
                description={t('common:developer.sdk.android.description')}>
                <Button endIcon="externalLink" $color="subsection" href="#">
                    {t('common:developer.sdk.android.action')}
                </Button>
            </CardIcon> */}
            <CardIcon
                name="logo"
                title={t('common:developer.sdk.docs.title')}
                description={t('common:developer.sdk.docs.description')}>
                <Button endIcon="externalLink" href="https://developers.cephable.com" $color="subsection">
                    {t('common:developer.sdk.docs.action')}
                </Button>
            </CardIcon>
            <CardCenteredContent
                name="sdk"
                title={t('common:developer.sdk.more.title')}
                description={t('common:developer.sdk.more.description')}>
                <Button
                    $color="secondary"
                    href="https://forms.office.com/Pages/ResponsePage.aspx?id=nXUREBN1JUCrY3YZ6NyUADMAro2v4K5DnCn2crFpV3hUOEY0OVhPTDE3REsyRU81QTBVVElTWkpMSC4u"
                    startIcon="plusLight">
                    {t('common:developer.sdk.more.action')}
                </Button>
            </CardCenteredContent>
        </CardSmallGrid>
    );
}
